import { QRCodeSVG } from "qrcode.react";
import { Smartphone } from "lucide-react";

/**
 * AppDownloadCard — kompakte Karte mit QR-Code zum App-Download.
 * Der QR-Code verweist auf die TwoWheels-Web-App (installierbar als PWA).
 */
export default function AppDownloadCard() {
    const appUrl = `${window.location.origin}/?install=app`;
    return (
        <div className="bg-[#111827] text-white rounded-sm p-5 flex items-center gap-4" data-testid="app-download-card">
            <div className="bg-white p-2 rounded-sm shrink-0">
                <QRCodeSVG value={appUrl} size={92} level="M" data-testid="app-download-qr" />
            </div>
            <div className="min-w-0">
                <div className="flex items-baseline gap-2 whitespace-nowrap">
                    <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider text-[#FFCC00] shrink-0">
                        <Smartphone className="w-3.5 h-3.5" /> Mobile App
                    </span>
                    <h3 className="font-display font-bold text-sm leading-tight truncate">App herunterladen</h3>
                </div>
                <p className="text-xs text-gray-300 mt-1">
                    QR-Code mit dem Handy scannen und TwoWheels als App installieren — Empfehlungen unterwegs erfassen &amp; Punkte sammeln.
                </p>
            </div>
        </div>
    );
}
